export default {
  GENERAL_ERROR: 'generalError',
};
